export default "__VITE_PUBLIC_ASSET__70cc5991__"